define('sentient/aba/models/SetupModel',[
	'underscore',
	'backbone'
	], function(_, Backbone) {
		var SetupmoDel = Backbone.Model.extend({
			noop: {'type': 'noop', 'options': {}},
			defaults: {
				RespId: '',
				ProjectId: '',
				Ex: []
			},
			init: {
			},
			serviceHost: '//api.sds-aba.com',
			urlRoot: '/projects/setup',
			url: function() {
				var base = _.result(this, 'serviceHost') + _.result(this, 'urlRoot') || urlError();
				var ex = this.get('Ex').slice(0);//Clone the array so we are not braking our own data with the shift()
				return [
					base,
					encodeURIComponent(this.get('ProjectId')),
					_.foldl(
						ex,
						function(memo, ex) {
							return memo + ':'+ encodeURIComponent(ex);
						},
						ex.shift().toString() //Start the fold left with the fist item on the array.
					),
					encodeURIComponent(this.get('RespId'))
				].join('/');
			}
		});
		return SetupmoDel;
	});

